if (typeof ProductCardCarousel === 'undefined') {
    class ProductCardCarousel extends HTMLElement {
        connectedCallback() {
            this.slideContentHeight = 0;
            this.handleResize = this.handleResize.bind(this);
            this.handleSwiperInit = this.handleSwiperInit.bind(this);
            
            // Get responsive settings from data attributes
            this.desktopCarousel = this.dataset.desktopCarousel === 'true';
            this.mobileCarousel = this.dataset.mobileCarousel === 'true';
            
            // Check current viewport
            this.isMobile = window.innerWidth < 1024; // lg breakpoint
            this.shouldShowCarousel = this.isMobile ? this.mobileCarousel : this.desktopCarousel;

            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            // Only initialize if carousel should be active for current viewport
            if (this.shouldShowCarousel) {
                whenReady('Swiper', this.handleSwiperInit);
            } else {
                // If no carousel needed, ensure proper grid layout
                this.setupGridLayout();
            }

            window.addEventListener('resize', this.handleResize);
        }

        handleSwiperInit() {
            try {
                const swiperContainer = this.querySelector('.swiper');
                if (!swiperContainer) {
                    console.warn('Swiper container not found');
                    return;
                }

                // Destroy existing swiper if it exists
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }

                this.swiper = new Swiper(swiperContainer, {
                    loop: false,
                    a11y: true,
                    slidesPerView: "auto",
                    pauseOnMouseEnter: false,
                    modules: [Swiper.Autoplay, Swiper.A11y],
                });

                this.updateSlideContentHeight(); // Initial setup
            } catch (error) {
                console.error('Failed to initialize Swiper:', error);
            }
        }

        setupGridLayout() {
            // Remove swiper classes and set up grid layout
            const swiperContainer = this.querySelector('.swiper');
            const swiperWrapper = this.querySelector('.swiper-wrapper');
            
            if (swiperContainer && swiperWrapper) {
                swiperContainer.classList.remove('swiper');
                swiperWrapper.classList.remove('swiper-wrapper');
                
                // Add grid classes for proper layout
                swiperWrapper.classList.add('large-card-grid');
                
                // Remove swiper-slide classes from children
                const slides = swiperWrapper.querySelectorAll('.swiper-slide');
                slides.forEach(slide => {
                    slide.classList.remove('swiper-slide');
                });
            }
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
            window.removeEventListener('resize', this.handleResize);
        }

        updateSlideContentHeight() {
            
            this.slideContentHeight = 0;
            const slides = this.querySelectorAll(".large-card__content");

            slides.forEach($slide => {
                $slide.style.height = 'auto'; // Reset before measuring
                if ($slide.clientHeight > this.slideContentHeight) {
                    this.slideContentHeight = $slide.clientHeight;
                }
            });

            slides.forEach($slide => {
                $slide.style.height = `${this.slideContentHeight}px`;
            });

        }

        handleResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                const wasMobile = this.isMobile;
                this.isMobile = window.innerWidth < 1024;
                const newShouldShowCarousel = this.isMobile ? this.mobileCarousel : this.desktopCarousel;
                
                // Check if carousel state needs to change
                if (this.shouldShowCarousel !== newShouldShowCarousel) {
                    this.shouldShowCarousel = newShouldShowCarousel;
                    this.toggleCarousel();
                } else if (this.shouldShowCarousel && this.swiper) {
                    // If carousel is still active, update slide heights
                    this.updateSlideContentHeight();
                }
            }, 150);
        }

        toggleCarousel() {
            // Find the container div (it might not have swiper class yet)
            const swiperContainer = this.querySelector('div:first-child');
            if (!swiperContainer) return;

            if (this.shouldShowCarousel) {
                // Switch to carousel mode
                this.setupCarouselLayout();
                // Add a small delay to ensure DOM changes are processed
                setTimeout(() => {
                    if (window.Swiper) {
                        this.handleSwiperInit();
                    } else {
                        whenReady('Swiper', this.handleSwiperInit);
                    }
                }, 50);
            } else {
                // Switch to grid mode
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }
                this.setupGridLayout();
            }
        }

        setupCarouselLayout() {
            // Find the container div (it might not have swiper class yet)
            const swiperContainer = this.querySelector('div:first-child');
            const swiperWrapper = swiperContainer?.querySelector('div:first-child');
            
            if (swiperContainer && swiperWrapper) {
                // Remove grid classes
                swiperWrapper.classList.remove('large-card-grid');
                
                // Add back swiper classes
                swiperContainer.classList.add('swiper');
                swiperWrapper.classList.add('swiper-wrapper');
                
                // Add swiper-slide classes back to children
                const slides = swiperWrapper.children;
                Array.from(slides).forEach(slide => {
                    slide.classList.add('swiper-slide');
                });
            }
        }
    }

    if (!window.customElements.get('large-card-carousel')) {
        window.customElements.define('large-card-carousel', ProductCardCarousel);
    }
}